import FundingPlaintiff from './FundingPlaintiff';

export default FundingPlaintiff;
